<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="toBusinessManagement">返回</a>
      </div>
    </div>
    <form>
      <a class="photoBox">
        <img :src="formData.yqPicUrl" id="peopleImg" v-if="formData.yqPicUrl" />
        <p v-if="!formData.yqPicUrl" >暂无人员照片</p>
      </a>
      <div class="form-line">
        <div class="line-text">姓名：</div>
        <div>{{formData.name || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">性别：</div>
        <div>{{formData.sex || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">民族：</div>
        <div>{{formData.nationCode || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">出生日期：</div>
        <div>{{formData.birthday || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">证件类型：</div>
        <div>{{formData.identityType || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">证件号码：</div>
        <div>{{formData.identityNumber || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">人员类型：</div>
        <div>{{formData.personTypeText || '无'}}</div>
      </div>
      <div class="form-line" v-if="formData.personType === 3">
        <div class="line-text">工种：</div>
        <div>{{formData.workTypeName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系手机：</div>
        <div>{{formData.phone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">承租主体：</div>
        <div>{{formData.leaseNameOnPage || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">房间号：</div>
        <div>{{formData.leaseRoomLabel || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">学历：</div>
        <div>{{formData.education || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">实体卡号：</div>
        <div>{{formData.cardNumberEntity || '无'}}</div>
      </div>

    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/Person'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'person-current',
    data () {
      return {
        yqCode: '',
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '人员管理'
        }],
        mainTitle: '查看人员',
        subheading: '',
        personTypeList: [
          {key: '', label: '全部'},
          {key: 1, label: '入住人'},
          {key: 2, label: '签约人'},
          {key: 3, label: '工作人员'},
          {key: 4, label: '管理员'},
          {key: 5, label: '家属人员'},
          {key: 0, label: '游客'},
        ],
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.yqCode = bus.global.yqCode
      this.currentCode = this.$route.params.id
      this.getPersonByCode()
    },
    methods: {
      toBusinessManagement () {
        this.$router.push({
          name: 'person-management'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/person_modify/${this.currentCode}`
        })
      },
      getPersonByCode () {
        this.$axios.get(`${api.getPersonByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.sex === '0') {
                data.sex = '男'
              } else if (data.sex === '1') {
                data.sex = '女'
              }
              data.leaseRoomLabel = ''
              if (data.bedsCode) {
                data.leaseRoomLabel = `${data.buildingName}/${data.floorName}/${data.roomNumber}/${data.bedsNumber}`
              } else if (data.buildingName) {
                data.leaseRoomLabel = `${data.buildingName}/${data.floorName}/${data.roomNumber}`
              }
              this.personTypeList.map(type => {
                if (type.key === data.personType && data.personType !== '') {
                  data.personTypeText = type.label
                }
              })
              let lease = data.lease || {}
              data.leaseNameOnPage = ''
              if (lease.mainType === 0) {
                data.leaseNameOnPage = lease.personName
              } else if (lease.mainType === 1) {
                data.leaseNameOnPage = lease.enterpriseName
              }
              if (data.workCode) {
                let workCode = data.workCode.split(',')
                let workTypeList = [
                  {code: '1', name: '物业派单人员'}
                ]
                let workTypeName = []
                workTypeList.map(v => {
                  if (workCode.indexOf(v.code) !== -1) {
                    workTypeName.push(v.name)
                  }
                })
                data.workTypeName = workTypeName.join(',')
              }
              this.formData = data
            }
          })
          .catch(errorHandler('查询人员失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    position: relative;
  }
  form .photoBox {
    width: 120px;
    height: 160px;
    border: 1px dashed #dcdfe6;
    border-radius: 5px;
    position: absolute;
    left: 450px;
    top: 0;
  }
  .photoBox img {
    width: 100%;
    height: 100%;
  }
  .photoBox p {
    color: #999999;
    font-size: 12px;
    line-height: 160px;
    text-align: center;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/PersonManagement/PersonCurrent.vue